<script lang="ts">
  import { goto } from "$app/navigation";

  import "@docsearch/css";
  import docsearch from "@docsearch/js";
  import { onMount } from "svelte";

  import "./Search.css";

  let container: HTMLElement;

  export let indexName: string;
  export let placeholder: string;
  export let onClose: (() => void) | undefined = undefined;

  onMount(() => {
    const style = getComputedStyle(container);
    // A hacky way preventing initalizing multiple docsearch() components on the same page.
    // This fixes a bug where we had two search modals and on the docs page.
    if (style.display === "none") {
      return;
    }
    docsearch({
      container,
      appId: "QCT5DT4VBL",
      apiKey: "9cb1f5f5f9d8e20a2597fbd839324093",
      indexName,
      placeholder,
      maxResultsPerGroup: 7,
      searchParameters: {
        hitsPerPage: 10,
      },
      navigator: {
        navigate(item) {
          goto(item.itemUrl);

          if (onClose) {
            onClose();
          }
        },
      },
      transformItems(items) {
        return items.map((item) => {
          return {
            ...item,
            url: item.url.replace(/^https:\/\/modal\.com/, ""),
          };
        });
      },
    });
  });
</script>

<div bind:this={container}></div>
